import type { Guide } from '../types';

/** S-20.10-08 — „Uwagi od FTL” dla przyjęcia zleceń (scenariusz e2e 15, ścieżka FTL-05). */
export const guide: Guide = {
  flagKey: 'ftlNotes',
  title: '„Uwagi od FTL” dla przyjęcia zleceń',
  whatItDoes:
    'Planista albo Team Leader dodaje na karcie zlecenia uwagę dla przyjęcia zleceń: kategoria (opóźnienie i ETA, niedostępność kierowcy, załadunek i rozładunek, dane zlecenia, inne), treść i znacznik „pilna”. Uwagi trafiają na listę „Uwagi od FTL” z licznikiem otwartych w menu; odbiorca zmienia stan uwagi (nowa, w toku, załatwiona) z komentarzem. Wszystko idzie do historii zlecenia, nic nie wychodzi pocztą.',
  audience: ['planista FTL', 'Team Leader (planista główny)', 'przyjęcie zleceń (CS)'],
  presentationItems: ['S-20.10-08'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: { description: 'dowolne zlecenie w planowaniu FTL', listPath: '/user-offers', listFilter: { forklift: 'hide', dzial: 'FTL' } },
      target: 'ftl-notes-section',
      mockupTestId: 'ftl-zlecenie-uwaga-cs',
      title: 'Uwaga dla CS na karcie zlecenia',
      description: 'Sekcja „Uwagi od FTL” na karcie zlecenia: dotychczasowe uwagi ze stanem i przycisk nowej uwagi.',
      action: 'Kliknij „Uwaga dla CS”, wybierz kategorię, wpisz treść (zaznacz „Pilna”, jeśli trzeba) i zapisz.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/004' } },
    },
    {
      route: '/ftl-notes',
      target: 'ftl-notes-inbox',
      title: 'Lista „Uwagi od FTL”',
      description:
        'Przyjęcie zleceń widzi uwagi z całego planowania, otwarte na górze, z licznikiem w menu. Stan zmienia z komentarzem — planista widzi odpowiedź przy uwadze.',
      action: 'Otwórz „Uwagi od FTL” w menu, przy uwadze wybierz „W toku” albo „Załatwiona” i dopisz komentarz.',
      recorder: { account: 'admin' },
    },
  ],
};
